import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import SEO from "@/components/SEO";
import { findPost } from "@/blog/posts";
import { ArrowLeft } from "lucide-react";

const BlogPostPage = () => {
  const { slug } = useParams();
  const { lang } = useApp();
  const post = findPost(slug);

  if (!post) return <Navigate to="/blog" replace />;

  const loc = post[lang] || post.fr;
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: loc.title,
    datePublished: post.date,
    author: { "@type": "Organization", name: "Lux·Pension" },
    keywords: post.keywords,
    description: loc.excerpt,
    inLanguage: lang,
  };

  return (
    <article className="max-w-3xl mx-auto px-6 md:px-8 py-16" data-testid={`blog-post-page-${post.slug}`}>
      <SEO title={loc.title} description={loc.excerpt} path={`/blog/${post.slug}`} jsonLd={jsonLd} />
      <Link to="/blog" data-testid="back-to-blog" className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.15em] text-slate-500 hover:text-slate-900 mb-8">
        <ArrowLeft size={12} strokeWidth={1.5} /> {lang === "fr" ? "Tous les guides" : lang === "de" ? "Alle Leitfäden" : "All guides"}
      </Link>
      <div className="text-[10px] font-mono uppercase tracking-widest text-slate-400">{post.date}</div>
      <h1 className="font-serif text-4xl sm:text-5xl tracking-tight text-slate-900 mt-3 mb-2">{loc.title}</h1>
      <p className="text-base text-slate-600 leading-relaxed border-b border-slate-200 pb-8 mb-8">{loc.excerpt}</p>

      <div
        className="blog-prose text-base text-slate-700 leading-relaxed space-y-5"
        dangerouslySetInnerHTML={{ __html: loc.body }}
      />
    </article>
  );
};

export default BlogPostPage;
